import {MaintenancePlan} from "@app/tool/model/toolMaintenance.model";
import {TaskInstructionFileModel} from "@models/task-instruction-file.model";
import { OperationTaskImageModel } from "./operation-task-image.model";

export enum TaskStatus {
    NEW = 0,
    DONE = 1,
    NOT_DONE = 2
}

export class ActivityTask {
    public id: number;
    public name: string;
    public description: string;
    public identifier: string;
    public status: TaskStatus;
    public activityId: number;
    public assignedRoleId: number;
    public assignedRole: any
    public duration: number;
    public files: TaskInstructionFileModel[];
    public hasSpare: boolean;
    public mandatorySpare: boolean;
    public photos: OperationTaskImageModel[];
    public requiresObservation: boolean;
    public spareCode: string;
    public spareQuantity: number;
    public unit: string;
    public maintenancePlans: MaintenancePlan[];

    constructor(task: any = {}) {
        this.id = task.id || 0;
        this.name = task.name || '';
        this.description = task.description || '';
        this.identifier = task.identifier || '';
        this.status = task.status || TaskStatus.NEW;
        this.activityId = task.activityId || 0;
        this.assignedRoleId = task.assignedRoleId || 0;
        this.assignedRole = task.assignedRole || null;
        this.duration = task.duration || 0;
        this.files = task.files.map(item => new TaskInstructionFileModel(item)) || [];
        this.hasSpare = task.hasSpare || false;
        this.photos = task.photos.map(item => new OperationTaskImageModel(item)) || [];
        this.requiresObservation = task.requiresObservation || false;
        this.spareCode = task.spareCode || "";
        this.spareQuantity = task.spareQuantity || 0;
        this.unit = task.unit || 'Minutes';
        this.mandatorySpare = task.mandatorySpare || false;
        this.maintenancePlans = task.maintenancePlans || [];
    }

    get type() {
        return 'task';
    }
}
